(function () {
	'use strict';

	angular.module('mx.components').controller('mx.shell.IconPickerDropdownController', [
		'$scope',
		'$timeout',
		'$element',
		function mxIconPickerDropdownCtrl($scope, $timeout, $element) {
			const vm = this;
			var allIcons = [];
			var initIconsAmount = 50;
			var containerEl;
			vm.filteredIcons = [];
			vm.__limit = initIconsAmount;
			vm.applyIcon = applyIcon;
			vm.$onInit = function () {
				initLibrary();

				setTimeout(function () {
					vm.__input.focus();
				}, 100);

				// Load more on scroll
				containerEl = $element.find('.mx-icon-picker--library');
				var clearWaitAppearence = $scope.$watch(
					function () {
						return containerEl.is(':visible');
					},
					function (isElVisible) {
						if (isElVisible) {
							setTimeout(_tryShowMoreDebounced, 1000);
							clearWaitAppearence();
						}
					}
				);
				containerEl.on('scroll', _tryShowMoreDebounced);

				// Close on click outside
				$element.click(function (event) {
					event.stopPropagation();
				});
				vm.__parentEl.click(function (event) {
					event.stopPropagation();
				});
				$(window).click(function () {
					close();
				});
			};

			$scope.$watch('vm.__parentVm.text', function (text) {
				search(text);
			});

			var _tryShowMoreDebounced = $.debounce(300, tryShowMore);

			function tryShowMore() {
				var res = false;
				var el = containerEl;
				if (vm.__limit <= vm.filteredIcons.length) {
					var fullHeight = el[0].scrollHeight;
					var currentHeigth = el.scrollTop() + el.innerHeight();
					if (vm.__limit <= vm.filteredIcons.length && currentHeigth > 0 && fullHeight > 0 && currentHeigth + 50 >= fullHeight) {
						res = true;
						$scope.$evalAsync(function () {
							vm.__limit += 100;
							setTimeout(_tryShowMoreDebounced, 1000);
						});
					}
				}
				return res;
			}

			function initLibrary() {
				mx.components.Icons.forEach(function (category) {
					category.icons.forEach(function (icon) {
						allIcons.push({
							id: icon.id,
							name: icon.name,
							categoryName: category.name,
						});
					});
				});

				vm.filteredIcons = allIcons.slice();
			}

			function search(text) {
				if (vm.__parentVm.model === vm.__parentVm.text) {
					text = '';
				}

				text = (text || '').toLowerCase();

				if (text) {
					vm.filteredIcons = allIcons.filter(function (icon) {
						return icon.name.indexOf(text) !== -1 || icon.id.indexOf(text) !== -1;
					});
					vm.__limit = initIconsAmount;
				} else if (vm.filteredIcons.length !== allIcons.length) {
					vm.filteredIcons = allIcons.slice();
				}
			}

			function applyIcon(icon) {
				vm.__parentVm.model = icon.id;
				vm.__parentVm.text = icon.id;
				vm.__parentVm.icon = icon.id;
				close();
			}

			function close() {
				vm.mdPanelRef.close();
			}
		},
	]);
})();
